import { render } from "./BundlesComponent.vue?vue&type=template&id=cfbbd74c"
import script from "./BundlesComponent.vue?vue&type=script&lang=js"
export * from "./BundlesComponent.vue?vue&type=script&lang=js"

import "./BundlesComponent.vue?vue&type=style&index=0&id=cfbbd74c&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__